<template>
  <div class="page-header-component">
    <div class="el-width-center">
      <div class="logo-area">
        <img
          :src="`/static/licp/images/logo_lite.png`"
          onerror="this.src = '/static/licp/images/logo_lite.png'"
          class="logo"
          ondragstart="return false"
        />
        <h1 class="title">汇泽医养信息云平台</h1>
      </div>
      <div class="navbar-area">
        <weather />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Weather from "@/components/Weather";
Vue.component("Weather", Weather);
export default {};
</script>

<style scoped>
.page-header-component {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to top, #dfe9f3 0%, #fafcff 100%);
  /*background-image: linear-gradient(45deg, #93a5cf 0%, #e4efe9 100%);*/
}
.logo-area {
  display: block;
  float: left;
  width: 320px;
  height: 60px;
}
.logo {
  margin-left: 10px;
  margin-top: 10px;
  width: 40px;
  float: left;
}
.title {
  display: block;
  float: left;
  line-height: 60px;
  white-space: nowrap;
  padding-left: 15px;
  font-family: "隶书", "chinese-simli";
  font-size: 25px;
}
.navbar-area {
  float: right;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  color: #0b6ca1;
}
.navbar-area i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue